import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 10h14l-4 -4","key":"svg-0"}],["path",{"d":"M17 14h-14l4 4","key":"svg-1"}]]

/**
 * IconArrowsExchange
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3dzLWV4Y2hhbmdlIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik03IDEwaDE0bC00IC00IiAvPgogIDxwYXRoIGQ9Ik0xNyAxNGgtMTRsNCA0IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/arrows-exchange
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowsExchange = createReactComponent('outline', 'arrows-exchange', 'ArrowsExchange', __iconNode);

export default IconArrowsExchange;